"use strict";

import angular from "angular";
import app from "velotooler-app";

angular.bootstrap(document, [app.name], {
  strictDi: true
});
